import { CookieHelper } from "./cookieHelper"
import { CreateGetParamHelper } from "./createGetParamHelper"
import { RequestHelper } from "@/helper/requestHelper"
import { DebugHelper } from "@/helper/debugHelper";

import { Const } from "@/const"
import { UserAgentHelper } from './userAgentHelper';
import platform from './platform';

export class LogHelper{
    public static sendLog(id : string, content : { [ key : string ] : string | number | null } | null, isStartup : boolean = false)
    {
        if(!isStartup && !CookieHelper.getItem("sendHistory")) { return; }

        // ログはmobileでは送らない
        if(UserAgentHelper.isMobile()) { return; }

        let uuid = ""
        let installId : any = ""
        let sessionId = ""

        //uuidがクッキーにない(末ログイン)の時でも空のuuidを送る
        if(CookieHelper.hasItem("authorizationToken")){
            uuid = CookieHelper.getItem("authorizationToken")
        }
        if(CookieHelper.hasItem("installId")){
            installId = CookieHelper.getItem("installId")
        }
        if(CookieHelper.hasItem("sessionId")){
            sessionId = CookieHelper.getItem("sessionId")
        }

        let request = {
            "platform" : String(platform.id),
            "uuid" : uuid,
            "installId" : installId.installId != null ? installId.installId : installId,
            "sessionId" : sessionId,
            "actionCode" : id,
            "actionContent" : content != null ? this.toJson(content) : ""
        }
        DebugHelper.trace(content);
        RequestHelper.post("log" , request , ()=>{},()=>{})
    }

    private static toJson(content : { [ key : string ] : string | number | null })
    {
        var json = "{";
        for(var key in content)
        {
            json += '"' + key + '" : "' + content[key] + '"';
            json += ",";
        }

        json = json.substr(0, json.length - 1);
        json += "}";
        return json;
    }
}
